import { useState } from 'react';
import { Alert, Box, Button, Grid, TextareaAutosize, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import Modal from '../ui/Modal';

// profesorul solicita modificari pentru cea mai recenta cerere a studentului (semnata sau nu)
function ModalModificari({ student, cerere, onInchide, onSucces }) {
    const SERVER = process.env.REACT_APP_SERVER;
    const [mesaj, setMesaj] = useState('');
    const [seTrimite, setSeTrimite] = useState(false);

    const trimite = async () => {
        setSeTrimite(true);
        try {
            const res = await fetch(`${SERVER}cerere/${cerere.id}/modificari`, {
                method: 'POST',
                headers: {
                    Authorization: localStorage.getItem('token'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ mesaj }),
            });
            const data = await res.json();
            if (!res.ok) {
                toast.error(data.error || 'Solicitarea nu a putut fi trimisă!');
                return;
            }
            toast.info('Ați solicitat modificări. Studentul a fost anunțat pe mail.');
            onSucces();
        } catch (e) {
            toast.error('Solicitarea nu a putut fi trimisă!');
        } finally {
            setSeTrimite(false);
        }
    };

    return (
        <Modal lung open={true} closed={onInchide}>
            <Grid>
                <Typography align="center" component="h5" variant="h5" sx={{ mb: 2 }}>
                    Solicitați modificări pentru cererea studentului {student.nume} {student.prenume}
                </Typography>
                <Alert severity="info" sx={{ mb: 2 }}>
                    Studentul va primi mesajul pe mail și va putea încărca o cerere corectată.
                    {cerere.e_semnat === 1
                        ? ' Cererea semnată rămâne valabilă până când o semnați pe cea nouă.'
                        : ' Cererea actuală nu va mai apărea la „De semnat” până la încărcarea celei corectate.'}
                </Alert>
                <TextareaAutosize
                    required
                    aria-label="Modificări solicitate"
                    placeholder="Descrieți ce trebuie corectat (ex. titlul, numele, semnătura)..."
                    minRows={6}
                    maxRows={10}
                    value={mesaj}
                    onChange={e => setMesaj(e.target.value)}
                    style={{ width: '100%', resize: 'none', padding: '0.7em', fontFamily: 'sans-serif', fontSize: '1.1em' }}
                />
                <Box>
                    <Button variant="contained" color="warning" sx={{ width: '45%', m: '2.5%' }}
                        disabled={mesaj.trim().length === 0 || seTrimite} onClick={trimite}>
                        Solicită modificări
                    </Button>
                    <Button variant="outlined" color="error" sx={{ width: '45%', m: '2.5%' }} onClick={onInchide}>
                        Renunță
                    </Button>
                </Box>
            </Grid>
        </Modal>
    );
}

export default ModalModificari;
